import { useNavigate, useSearchParams } from 'react-router-dom';
import { GuestAuthChallenge, GuestNotice } from './GuestAuthChallenge';
import { GuestCard } from './GuestCard';
import { getGuestSession, guestQuotePath } from '../../lib/guest-session';

/**
 * Landing page for an emailed guest acceptance link.
 *
 * Only ever the *entry* point — once a guest holds a session they live on
 * /guest/quotes/:id, which recovers a lapsed session in place rather than
 * sending them back here.
 */
export function GuestAcceptPage() {
	const [searchParams] = useSearchParams();
	const navigate = useNavigate();

	const linkToken = searchParams.get('token') ?? getGuestSession()?.linkToken ?? null;

	if (!linkToken) {
		return (
			<GuestCard>
				<GuestNotice
					title="This link is incomplete"
					detail="Open the link from your email again — it carries a code this page needs."
				/>
			</GuestCard>
		);
	}

	return (
		<GuestCard>
			<GuestAuthChallenge
				linkToken={linkToken}
				onAuthenticated={(orderQuoteId) =>
					navigate(guestQuotePath(orderQuoteId), { replace: true })
				}
			/>
		</GuestCard>
	);
}
